var render = function render(){var _vm=this,_c=_vm._self._c;return _c('primary-btn',{attrs:{"loading":_vm.getStartedState.loading},nativeOn:{"click":function($event){return _vm.getStartedClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }